import { createSlice } from '@reduxjs/toolkit';

import { addStateFetch } from '@webapp/account/src/resources/store-utils';

import { initialState } from './api';
import { getTokens } from './async';

export const apiSlice = createSlice({
    name: 'api',
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        addStateFetch(
            builder.addCase(getTokens.fulfilled, (s, { payload: items }) => {
                s.tokens = items;
            }),
        ),
});
